module.exports = __webpack_public_path__ + "static/media/service-img.1d87c3c7.png";